module.exports = __webpack_public_path__ + "media/images/credit_cards-1d59c2f5904f0e486dfcfd4dcf8864ae.png";